export default "__VITE_ASSET__MZ$PtfIq__"